/* eslint-disable no-unused-vars */
import React,{useState,useEffect} from 'react'
import './style.css';
import axios from 'axios';
import { TextField } from '@mui/material';
import { Typography } from '@material-ui/core';
const SocialLinks = () => {
    const getbyValue = (arr,value)=>{
       console.log(arr)
        var result =arr.filter(function(o){  return o.name===value });
          try{
            console.log(result[0].linktext)
            return result ? result[0].linktext : '';

          }catch(err){
              console.log(err)
          }
    }
    const getVal =(medialinks,title)=>{
        console.log(medialinks[0])
      try{
        var obj=null;
        for (let i=0 ;i <=  medialinks.length;i++){
            if (medialinks[i].title===title){

                console.log(medialinks[i])
                obj=medialinks[i];
            }
        }
        return obj.linktext;
      }catch(err){
          console.log(err)
      }
    }
    const [medialinks,setMedialinks]=useState([])
    const [faceBook,setFaceBook]=useState('');
    const [twitter,setTwitter]=useState('');
    const [telegram,setTelegram]=useState(''); 
    const [whatsapp,setWhatsApp]=useState(''); 
    const [instagram,setInstagram]=useState(''); 
    const [islinksloaded,setIslinksLoaded]=useState(false);

    const handleSubmit=(e)=>{
       e.preventDefault();
       //createNewUser(e)
    };
    const getObjectbyValue =(obj,name)=>{
        var result =obj.filter(obj => {
            console.log(obj)
            return  obj.name===name
        });
    }  
   


    const handleOnInstagramChange=(e)=>{
        setInstagram(e.target.value)
         updatelink();
    }
    const handleOnFacebookChange=(e)=>{
        setFaceBook(e.target.value)
         updatelink();
    }
    const handleOnTwitterChange=(e)=>{
        setTwitter(e.target.value)
         updatelink();
    }

    const handleOnTelegramChange=(e)=>{
        setTelegram(e.target.value)
         updatelink();
    }
    const handleOnWhatsappChange=(e)=>{
        setWhatsApp(e.target.value)
         updatelink();
    }
    const updatelink = async ()=>{
        const medialinks = [{
                title:'Facebook',
                linktext:faceBook
            },
            {
                title:'Instagram',
                linktext:instagram
            },  {
                title:'Twitter',
                linktext:twitter
            },  {
                title:'Telegram',
                linktext:telegram
            },  {
                title:'WhatsApp',
                linktext:whatsapp
            },]
            
        
        const url=`${process.env.REACT_APP_SERVER_URL}/socialmedialinks`

        await axios.post(url,{ linktype:'social',medialinks:JSON.stringify(medialinks)}).then((response)=>{
            //console.log(response)
            setMedialinks(response.data.socialmedialinks);
        })  
      }
      
    useEffect(()=>{
        const handlegetLinks = async ()=>{
            const url=`${process.env.REACT_APP_SERVER_URL}/socialmedialinks`
    
            await axios.get(url).then((response)=>{
                console.log(response.data.socialmedialinks[0].medialinks[0].linktext);
                setMedialinks(response.data.socialmedialinks[0].medialinks);
              try{
                setFaceBook(response.data.socialmedialinks[0].medialinks[0].linktext)
                setTwitter(response.data.socialmedialinks[0].medialinks[1].linktext)
                setInstagram(response.data.socialmedialinks[0].medialinks[2].linktext)
                setTelegram(response.data.socialmedialinks[0].medialinks[3].linktext)
                setWhatsApp(response.data.socialmedialinks[0].medialinks[4].linktext)

                //getObjectbyValue(response.data.socialmedialinks,'Twitter')
              }catch(err){
                  console.log(err)
              }
            })
        }

        if (!islinksloaded){
           handlegetLinks();
        }
        return ()=>{
            setIslinksLoaded(true)
        }
    })
  return (
    <div className='sociallink'>
        {

        }
       <form action="" className="social-media-link" onSubmit={handleSubmit}>
            <div className="social-media-link-item">
            <Typography align='left' color='textSecondary'>FaceBook</Typography>
                <TextField  variant='outlined'  placeholder="https://www.facebook.com/#" sx={{width:'60%'}} value={faceBook} required onChange={(e)=>{handleOnFacebookChange(e)}} />
            </div>
            <div className="social-media-link-item">
            <Typography align='left' color='textSecondary'>Twitter</Typography>
                
                <TextField  variant='outlined'  placeholder="https://www.twitter.com/#" sx={{width:'60%'}} value={twitter} required onChange={(e)=>{handleOnTwitterChange(e)}} />
            </div>
            <div className="social-media-link-item">
            <Typography align='left' color='textSecondary'>Instagram</Typography>
                 
                <TextField  variant='outlined'  placeholder="https://www.instagram.com/#" sx={{width:'60%'}} value={instagram} required onChange={(e)=>{handleOnInstagramChange(e)}} />
            </div>
          
            <div className="social-media-link-item">
            <Typography align='left' color='textSecondary'>Telegram</Typography>
              
                <TextField  variant='outlined'  placeholder="https://t.me/#" sx={{width:'60%'}} value={telegram} required onChange={(e)=>{handleOnTelegramChange(e)}} />
            </div>
            <div className="social-media-link-item">
                <Typography align='left' color='textSecondary'>WhatsApp</Typography>
                <TextField  variant='outlined'  placeholder="https://chat.whatsapp.com/#" sx={{width:'60%'}} value={whatsapp} required onChange={(e)=>{handleOnWhatsappChange(e)}} />
            </div>
          

            
          {/*  <div className="social-media-link-item">
           <button className="newUserButton">Save</button>
           </div> */}
            </form>
    </div>
  )
}

export default SocialLinks
